import { createFileRoute, redirect } from '@tanstack/react-router';
import { CreateStaffForm } from '../../../features/staff/components/CreateStaffForm';
import { FormPageLayout } from '../../../components/layout/FormPageLayout';
import { usePageTitle } from '../../../lib/hooks';
import { getSession } from '../../../lib/session';

export const Route = createFileRoute('/_auth/users/new')({
  beforeLoad: ({ location }) => {
    const session = getSession();
    const isAllowed =
      session?.user.type === 'group_admin' ||
      session?.user.type === 'company_admin' ||
      session?.permissions.includes('user.create');
    if (!isAllowed) {
      throw redirect({ to: '/', search: { callbackUrl: location.href } });
    }
  },
  component: CreateUserPage,
});

function CreateUserPage() {
  usePageTitle('Add New User');

  return (
    <FormPageLayout
      title="Add New User"
      subtitle="Provision a new system identity, configure their primary branch, and assign system permissions."
      backTo="/users"
      variant="card"
    >
      <CreateStaffForm />
    </FormPageLayout>
  );
}
